import { render, staticRenderFns } from "./DialogId6.vue?vue&type=template&id=31c64dee&scoped=true&"
import script from "./DialogId6.vue?vue&type=script&lang=js&"
export * from "./DialogId6.vue?vue&type=script&lang=js&"
import style0 from "./DialogId6.vue?vue&type=style&index=0&id=31c64dee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c64dee",
  null
  
)

export default component.exports